/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Still_Heavy_Porpoise_SkipInputs */

const fr_still_heavy_porpoise_skip = /** @type {(inputs: Still_Heavy_Porpoise_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion au site`)
};

/**

* @param {Still_Heavy_Porpoise_SkipInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const still_heavy_porpoise_skip = /** @type {((inputs?: Still_Heavy_Porpoise_SkipInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Still_Heavy_Porpoise_SkipInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_still_heavy_porpoise_skip(inputs)
});